import { useNavigate } from "react-router-dom";
import close from "../assets/images/model/close.svg";
import Loader from "../components/Loader";

export const CustomModal = ({
  onHide,
  onAction,
  showModal,
  error = "",
  title = "",
  content = "",
  isLink = false,
  loading = false,
  is_delete = false,
  className = "gap-40",
  otherContent = "",
  actionBtnText = "",
  cancelBtnText = "",
  supportContent = "",
  title_matched = false,
  children = null,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className="modal custom_background custom_modal_create"
      id="select_an_option"
      style={{ display: showModal ? "block" : "none" }}
      tabIndex="-1"
      aria-labelledby="select_an_optionLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onHide}
            >
              <img src={close} alt="close" />
            </button>
          </div>
          <div
            className={`modal-body-cre d-flex flex-column justify-content-center ${className}`}
          >
            <div>
              <h4>{title}</h4>
              <p className="mb-0">
                {content}
                {supportContent && (
                  <span>
                    <u style={{ fontWeight: "500" }}>{supportContent}</u>
                  </span>
                )}
              </p>
              {otherContent && (
                <p className="mb-0" style={{ paddingTop: "20px" }}>
                  {otherContent}
                </p>
              )}
            </div>
            {children}
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="modal-footer">
              {/* extra class name need to pass to toggle btn background colors */}
              {/* use this class for disable button text-grey-600 */}
              <button
                className={`modal_footer_primary_btn cursor ${
                  is_delete ? (title_matched ? "disable" : "delete-model") : ""
                }`}
                type="button"
                disabled={title_matched}
                onClick={onAction}
              >
                {loading ? (
                  <div className="loader">
                    {" "}
                    <Loader color="lightgrey" />
                  </div>
                ) : (
                  actionBtnText
                )}
              </button>
              <button
                className="modal_footer_secondary_btn cursor"
                onClick={() => {
                  if (isLink) {
                    localStorage.setItem("status", false);
                    navigate("/dashboard");
                  } else onHide();
                }}
              >
                {cancelBtnText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
